'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lib = require('../lib-26f8f706.js');
var definitions = require('../definitions-0c162dc8.js');
var card_index = require('./index.js');
require('tslib');
require('react');
require('styled-components');
require('../measurements-4d464873.js');
require('../light-theme-colors-bb1a2999.js');
require('../utils-9a8db0ee.js');
require('../env-100217af.js');

var RowCard = lib.variant('RowCard', card_index.Card, {
    direction: definitions.Axis.X,
});
var ColumnCard = lib.variant('ColumnCard', card_index.Card, {
    direction: definitions.Axis.Y,
});

exports.ColumnCard = ColumnCard;
exports.RowCard = RowCard;
//# sourceMappingURL=variants.js.map
